import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { SnapElemnt } from '../manager/SnapManager';
import ItemControllerRoom from './ItemControllerRoom';

export default class ItemControllerRoomMansion extends ItemControllerRoom {
    movePickerWallList: marietta.webcad.control.parts.RoomMovePickerWall[];

    startP1: marietta.core.Point;

    startP2: marietta.core.Point;

    snapList: SnapElemnt[];

    initSnap: boolean = false;

    startCoordinatesWall: marietta.webcad.collection.PointCollection[];

    selectedPicker:marietta.webcad.control.parts.RoomCornerDragger|marietta.webcad.control.parts.RoomMovePickerWall = null;

    /**
   * コンストラクタ
   */
    constructor(_target: marietta.webcad.item.MonicaObject) {
      super(_target);
      this.reInitController();
    }

    reInitController() {
      document.getElementById('controller').remove();
      const viewObj: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.id = 'controller';
      this.spt = new SVGSprite(viewObj);

      // ビューの初期化
      this.initMe();
      if (this.target.itemInfo.lock) {
        this.hideToolTips();
      } else {
        this.showToolTips();
      }
    }

    /**
     * 初期化
     */
    initMe() {
      this.movePickerList = [];
      this.cornerPickerList = [];
      this.movePickerWallList = [];
      this.selectedPicker = null;

      // 既存のスナップガイドを削除
      if (document.getElementById('controller_snap_guide'))document.getElementById('controller_snap_guide').remove();
      marietta.webcad.WebCADGlobal.snapManager.hideAll();

      // コントローラー追加
      let corner: marietta.webcad.control.parts.RoomCornerDragger;
      let wallPicker: marietta.webcad.control.parts.RoomMovePickerWall;
      for (let i: number = 1; i <= this.target.itemInfo.dotList.length; i += 1) {
        wallPicker = new marietta.webcad.control.parts.RoomMovePickerWall(this.spt, i);
        wallPicker.moveFunc = this.onMoveWallDragger;
        wallPicker.moveEndFunc = this.onMoveEndWallDragger;
        // wallPicker.hideSetting = this.hideSettingButtons;
        this.movePickerWallList.push(wallPicker);
      }
      for (let i: number = 1; i <= this.target.itemInfo.dotList.length; i += 1) {
        corner = new marietta.webcad.control.parts.RoomCornerDragger(this.spt, i);
        corner.moveFunc = this.onMoveCornerDragger;
        corner.moveEndFunc = this.onMoveEndCornerDragger;
        this.cornerPickerList.push(corner);
      }

      // 作成する階
      const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
      tarLayer.spt.addChild(this.spt);

      marietta.webcad.WebCADGlobal.snapManager.createSnapGuide(tarLayer); // スナップガイドを作成

      // コントローラーの位置調整
      this.setArrowPositions();

      // ターゲットに合わせてサイズ変更
      this.resizeToTarget();
    }

    /**
     * ピッカーのサイズ更新
     */
    public updatePickers(): void {
      for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
        (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).updateTranslate();
      }
    }

    /**
     * コントロールピッカーが移動された
     */
    onMoveCornerDragger = (e: MouseEvent, target: marietta.webcad.control.parts.RoomCornerDragger) => {
      // ロックされている場合は、行わない
      if (!this.target.isCapableOfResize()) return;
      // 開始時のアイテム場所保持
      if (this.startPoint === undefined || this.startPoint === null) {
        this.currentWall = target;
        this.initSnap = true;
        if (this.emptySpt === undefined || this.emptySpt === null) {
          this.emptySpt = new SVGSprite(null, true);
          this.emptySpt.setEmptyParam(this.target.spt);
          this.target.spt.parent.addChild(this.emptySpt);
        }

        this.startPoint = new marietta.core.Point(this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.mouseY * this.target.spt.scaleY);
      }

      // add horizontal and vertical snap for target
      if (this.initSnap) {
        this.initSnap = false;
        this.snapList = [];
        this.snapList = marietta.webcad.WebCADGlobal.snapManager.snapElements.map((m) => m);

        let a; let b; let c;
        if (this.target instanceof marietta.webcad.item.Beam) {
          this.target.itemInfo.globalDotList.forEach((dot) => {
            ({ a, b, c } = marietta.webcad.WebCADGlobal.snapManager.horizontalLine(dot.y));
            marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, marietta.webcad.manager.SnapManager.CURRENT_GUIDE_PRIORITY, null, true, true); // 水平線スナップを追加
            ({ a, b, c } = marietta.webcad.WebCADGlobal.snapManager.verticalLine(dot.x));
            marietta.webcad.WebCADGlobal.snapManager.addLineSnap(this.snapList, a, b, c, marietta.webcad.manager.SnapManager.SNAP_RADIUS, marietta.webcad.manager.SnapManager.CURRENT_GUIDE_PRIORITY, null, true, true); // 垂直線スナップを追加
          });
        }
      }

      const newPoint: marietta.core.Point = new marietta.core.Point(this.emptySpt.x + this.emptySpt.mouseX * this.target.spt.scaleX, this.emptySpt.y + this.emptySpt.mouseY * this.target.spt.scaleY);
      // アイテムの角度分、座標変換を行う
      const r: number = (-(this.target.spt.rotation % 360) / 180) * Math.PI;
      const xx: number = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
      const yy: number = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
      newPoint.x = xx;
      newPoint.y = yy;

      // オブジェクト吸着が拘束する軸はそのまま、残りの軸をグリッドへ吸着させる
      const snap = this.getSnapPosition(newPoint);
      const snapPosition: marietta.core.Point = marietta.webcad.util.WebCADUtil
        .snapPointToGrid(snap.point, snap.lockX, snap.lockY);
      target.move(snapPosition.x - this.emptySpt.x, snapPosition.y - this.emptySpt.y);

      // 部屋を同期させる
      this.setRoomToMe();
    }

    /**
     * 壁点は他の点とオーバーラップしているか
     * 壁を削除する
     * @param target
    */
    checkPointOverlap(target:marietta.webcad.control.parts.RoomCornerDragger, resolve:Function = null) {
      const tarIndex = target.index - 1;
      const nextIndex = tarIndex < this.target.itemInfo.dotList.length - 1 ? tarIndex + 1 : 0;
      const prevIndex = tarIndex > 0 ? tarIndex - 1 : this.target.itemInfo.dotList.length - 1;
      let deleteIndex = null;
      let pointCorrection = null;

      if (marietta.core.Point.distance(this.target.itemInfo.dotList[nextIndex].point, this.target.itemInfo.dotList[tarIndex].point) <= 3) {
        deleteIndex = tarIndex;
      } else if (marietta.core.Point.distance(this.target.itemInfo.dotList[prevIndex].point, this.target.itemInfo.dotList[tarIndex].point) <= 3) {
        deleteIndex = prevIndex;
        pointCorrection = this.target.itemInfo.dotList[prevIndex];
      }
      if (deleteIndex != null) {
        if (pointCorrection != null) {
          this.target.itemInfo.dotList[tarIndex].x = this.target.itemInfo.dotList[prevIndex].x;
          this.target.itemInfo.dotList[tarIndex].y = this.target.itemInfo.dotList[prevIndex].y;
        }
        this.target.itemInfo.dotList.splice(deleteIndex, 1);
        this.target.reCreateImage();
        this.reInitController();
      }
      if (resolve) {
        resolve();
      }
    }

    /**
     * コントロールピッカーのドラッグ終了
     */
    onMoveEndCornerDragger = (e: MouseEvent, target: marietta.webcad.control.parts.RoomCornerDragger) => {
      const p = new Promise((resolve: Function, reject: Function) => {
        this.checkPointOverlap(target, resolve);
      });
      p.then(() => {
        this.startPoint = null;
        this.currentWall = null;

        if (this.emptySpt && this.emptySpt.parent) {
          this.emptySpt.parent.removeChild(this.emptySpt);
          this.emptySpt = null;
        }

        // 面積ゼロなら削除
        ItemControllerRoom.areaZeroRemove();

        // ライン測定を更新する
        marietta.webcad.WebCADGlobal.updateMeasureLine(false);
        // cornerDragの最後に測定線を表示する
        marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
        marietta.webcad.WebCADGlobal.snapManager.hideAll();

        marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
        marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
        this.target.setParentRoom();

        marietta.webcad.WebCADGlobal.quotationItemList.createData();
      });
    }

    /**
   * コントロールピッカーが移動された
   */
    onMoveWallDragger = (e: MouseEvent, target) => {
      // ロックされている場合は、行わない
      if (!this.target.isCapableOfResize()) return;

      // カレント
      this.currentWall = <marietta.webcad.control.parts.RoomMovePickerWall>target;

      // 前後のドット
      const partnerDotList = [];
      // 前のドット
      if (this.currentWall.index === this.cornerPickerList.length) {
        partnerDotList.push(this.cornerPickerList[this.cornerPickerList.length - 1]);
      } else {
        partnerDotList.push(this.cornerPickerList[this.currentWall.index - 1]);
      }
      // 次のドット
      if (this.currentWall.index === this.cornerPickerList.length) {
        partnerDotList.push(this.cornerPickerList[0]);
      } else {
        partnerDotList.push(this.cornerPickerList[this.currentWall.index]);
      }

      // ピッカーのXYのいずれかが共通していたら、コーナーのスナップ方式と同等にする。そうでなければ従来の方式にする
      let newPoint: marietta.core.Point;
      let r: number;
      let xx: number;
      let yy: number;

      if (partnerDotList[0].x === partnerDotList[1].x || partnerDotList[0].y === partnerDotList[1].y) {
        // 開始時のアイテム場所保持
        if (this.startPoint === undefined || this.startPoint === null) {
          this.initSnap = true;
          if (this.emptySpt === undefined || this.emptySpt === null) {
            this.emptySpt = new SVGSprite(null, true);
            this.emptySpt.setEmptyParam(this.target.spt);
            this.target.spt.parent.addChild(this.emptySpt);
          }
          this.startPoint = new marietta.core.Point(
            this.emptySpt.mouseX * this.target.spt.scaleX,
            this.emptySpt.mouseY * this.target.spt.scaleY,
          );
          // 開始時の座標
          this.startCoordinatesWall = this.target.itemInfo.dotList.concat();
        }
        if (this.initSnap) {
          this.initSnap = false;
          this.snapList = [];
          this.snapList = marietta.webcad.WebCADGlobal.snapManager.snapElements.map((m) => m);
        }
        newPoint = new marietta.core.Point(
          this.emptySpt.x + this.emptySpt.mouseX * this.target.spt.scaleX,
          this.emptySpt.y + this.emptySpt.mouseY * this.target.spt.scaleY,
        );
        // アイテムの角度分、座標変換を行う
        r = (-(this.target.spt.rotation % 360) / 180) * Math.PI;
        xx = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
        yy = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
        newPoint.x = xx;
        newPoint.y = yy;

        // オブジェクト吸着が拘束する軸はそのまま、残りの軸をグリッドへ吸着させる
        const snap = this.getSnapPosition(newPoint);
        const snapPosition: marietta.core.Point = marietta.webcad.util.WebCADUtil
          .snapPointToGrid(snap.point, snap.lockX, snap.lockY);
        if (partnerDotList[0].x === partnerDotList[1].x) {
          target.moveX(snapPosition.x - this.emptySpt.x);
          partnerDotList[0].moveX(snapPosition.x - this.emptySpt.x);
          partnerDotList[1].moveX(snapPosition.x - this.emptySpt.x);
        } else {
          target.moveY(snapPosition.y - this.emptySpt.y);
          partnerDotList[0].moveY(snapPosition.y - this.emptySpt.y);
          partnerDotList[1].moveY(snapPosition.y - this.emptySpt.y);
        }
        // 部屋を同期させる
        this.setRoomToMe();

        this.startPoint = null;
        this.currentWall = null;

        if (this.emptySpt && this.emptySpt.parent) {
          this.emptySpt.parent.removeChild(this.emptySpt);
          this.emptySpt = null;
        }
      }
      //----------------------------------------------------

      if (this.currentWall === null || this.currentWall === undefined) return;

      // 開始時のアイテム場所保持
      if (!this.startP1 || !this.startP2) {
        this.initSnap = true;
        if (this.emptySpt === undefined || this.emptySpt === null) {
          /*
            本来はtarget.sptのmouseX/mouseYで取得できるが、
            拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
            そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
            取得している。
        */
          this.emptySpt = new SVGSprite(null, true);
          this.emptySpt.setEmptyParam(this.target.spt);
          this.target.spt.parent.addChild(this.emptySpt);
        }

        this.startPoint = new marietta.core.Point(
          this.emptySpt.mouseX * this.target.spt.scaleX,
          this.emptySpt.mouseY * this.target.spt.scaleY,
        );

        this.startP1 = new marietta.core.Point(partnerDotList[0].x, partnerDotList[0].y);
        this.startP2 = new marietta.core.Point(partnerDotList[1].x, partnerDotList[1].y);

        // 開始時の座標
        this.startCoordinatesWall = this.target.itemInfo.dotList.concat();
      }

      if (this.initSnap) {
        this.initSnap = false;
        this.snapList = [];
        this.snapList = marietta.webcad.WebCADGlobal.snapManager.snapElements.map((m) => m);
      }

      newPoint = new marietta.core.Point(
        this.emptySpt.mouseX * this.target.spt.scaleX,
        this.emptySpt.mouseY * this.target.spt.scaleY,
      );

      // アイテムの角度分、座標変換を行う
      r = (-(this.target.spt.rotation % 360) / 180) * Math.PI;
      xx = newPoint.x * Math.cos(r) - newPoint.y * Math.sin(r);
      yy = newPoint.x * Math.sin(r) + newPoint.y * Math.cos(r);
      newPoint.x = xx;
      newPoint.y = yy;
      // 移動距離
      // let snap_unit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      let tempMoveAmountX: number = (newPoint.x - this.startPoint.x);
      let tempMoveAmountY: number = (newPoint.y - this.startPoint.y);

      const p1 = new marietta.core.Point(this.startP1.x + tempMoveAmountX, this.startP1.y + tempMoveAmountY);
      const p2 = new marietta.core.Point(this.startP2.x + tempMoveAmountX, this.startP2.y + tempMoveAmountY);
      const snap1 = this.getSnapPosition(p1);
      const snap2 = this.getSnapPosition(p2);
      if (snap1 && snap1.snaped) {
        if (snap2.snaped && snap2.distance < snap1.distance) {
          tempMoveAmountX = (snap2.point.x - this.startP2.x);
          tempMoveAmountY = (snap2.point.y - this.startP2.y);
        } else {
          tempMoveAmountX = (snap1.point.x - this.startP1.x);
          tempMoveAmountY = (snap1.point.y - this.startP1.y);
        }
      }
      if (snap2 && snap2.snaped) {
        if (snap1.snaped && snap1.distance < snap2.distance) {
          tempMoveAmountX = (snap1.point.x - this.startP1.x);
          tempMoveAmountY = (snap1.point.y - this.startP1.y);
        } else {
          tempMoveAmountX = (snap2.point.x - this.startP2.x);
          tempMoveAmountY = (snap2.point.y - this.startP2.y);
        }
      }

      this.moveAmountX = tempMoveAmountX;
      this.moveAmountY = tempMoveAmountY;

      // 部屋を同期させる
      this.resizeRoomToMe();
    }

    /**
    * 部屋の大きさをあわせる
    * */
    resizeRoomToMe=(force: boolean = false) => {
      if (force) this.prevPoint = null;

      // 前回と同じ位置なら、行わない
      if (this.prevPoint != null && (this.prevPoint.x === this.emptySpt.mouseX && this.prevPoint.y === this.emptySpt.mouseY)) return;
      this.prevPoint = new marietta.core.Point(this.emptySpt.mouseX, this.emptySpt.mouseY);

      // ドラッグ開始時の頂点をコピー
      const newCoordinates: marietta.webcad.collection.PointCollection[] = [];
      for (let i: number = 0; i < this.movePickerWallList.length; i += 1) {
        newCoordinates.push(new marietta.webcad.collection.PointCollection(this.startCoordinatesWall[i].x, this.startCoordinatesWall[i].y, this.startCoordinatesWall[i].wall_type));
      }
      // ドラッグしている辺に影響する頂点の座標を変更する
      const { index } = this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall;
      const p1: number = index - 1;
      const p2: number = (index === this.movePickerWallList.length) ? 0 : index;

      // 方向を特定する
      let vertical: Boolean = false;
      if ((this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === 90 || (this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === -90) {
        vertical = true;
      }
      // 方向を特定する
      if ((this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation % 90 === 0 || (this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === 0) {
        if ((this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === 90 || (this.currentWall as marietta.webcad.control.parts.RoomMovePickerWall).rotation === -90) {
          vertical = true;
        }
        // 頂点を変更する
        newCoordinates[p1].x += vertical ? 0 : this.moveAmountX;
        newCoordinates[p1].y += vertical ? this.moveAmountY : 0;
        newCoordinates[p2].x += vertical ? 0 : this.moveAmountX;
        newCoordinates[p2].y += vertical ? this.moveAmountY : 0;
      } else {
        // 頂点を変更する
        newCoordinates[p1].x += this.moveAmountX;
        newCoordinates[p1].y += this.moveAmountY;
        newCoordinates[p2].x += this.moveAmountX;
        newCoordinates[p2].y += this.moveAmountY;
      }
      this.target.itemInfo.dotList = newCoordinates;
      this.target.reCreateImage();

      // 関連するシンボルの位置移動
      this.setArrowPositions();
    }

    /**
    * コントロールピッカーのドラッグ終了
    */
    onMoveEndWallDragger = () => {
      this.startPoint = null;
      this.startP1 = null;
      this.startP2 = null;
      this.startCoordinatesWall = null;
      this.currentWall = null;
      this.prevPoint = null;

      if (this.emptySpt && this.emptySpt.parent) {
        this.emptySpt.parent.removeChild(this.emptySpt);
        this.emptySpt = null;
      }

      // 面積ゼロなら削除
      ItemControllerRoom.areaZeroRemove();
      let crossPoint = null;
      if (this.target.wallObjList && this.target.wallObjList.length > 0) {
        for (let j: number = 0; j < this.target.wallObjList.length; j += 1) {
          const l1p1 = new marietta.core.Point(this.target.wallObjList[j].startDot.x, this.target.wallObjList[j].startDot.y);
          const l1p2 = new marietta.core.Point(this.target.wallObjList[j].endDot.x, this.target.wallObjList[j].endDot.y);
          for (let i = 0; i < this.target.wallObjList.length; i += 1) {
            if (this.target.wallObjList[j].index !== this.target.wallObjList[i].index) {
              const l2p1 = new marietta.core.Point(this.target.wallObjList[i].startDot.x, this.target.wallObjList[i].startDot.y);
              const l2p2 = new marietta.core.Point(this.target.wallObjList[i].endDot.x, this.target.wallObjList[i].endDot.y);
              if (!(l1p2.distanceTo(l2p1) < 0.001 || l2p2.distanceTo(l1p1) < 0.001)) {
                crossPoint = marietta.webcad.util.WebCADUtil.getLineCrossPointInsideLines(l1p1, l1p2, l2p1, l2p2);
                if ((l1p1.distanceTo(l2p1) === 0 && l1p2.distanceTo(l1p2) === 0) || (l1p1.distanceTo(l2p2) === 0 && l1p2.distanceTo(l1p1) === 0)) crossPoint = l1p1;
                if (crossPoint != null) break;
              }
            }
          }
          if (crossPoint != null) break;
        }
      }
      if (crossPoint != null) marietta.webcad.WebCADGlobal.webcad2Dmanager.updateRoomInfo();
      // ライン測定を更新する
      marietta.webcad.WebCADGlobal.updateMeasureLine(false);
      // cornerDragの最後に測定線を表示する
      marietta.webcad.WebCADGlobal.itemManager.showMeasureLine();
      marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
      marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
      // marietta.webcad.WebCADGlobal.itemManager.setWallDirection();
      marietta.webcad.WebCADGlobal.snapManager.hideAll();
      // this.target.itemInfo.updateRoomArea(true, false, true, false, false);

      this.target.setParentRoom();
      marietta.webcad.WebCADGlobal.quotationItemList.createData();

    }

    /**
     * スナップ
     * @param p
     * @returns
     */
    getSnapPosition(p: marietta.core.Point) {
      let snap = null;
      let snaped = false;
      // 吸着要素が拘束する軸。拘束されない軸は呼び出し側でグリッドに吸着させる
      let lockX = false;
      let lockY = false;
      const snapPoint: marietta.core.Point = p.clone();
      marietta.webcad.WebCADGlobal.snapManager.hideAll();
      snap = marietta.webcad.WebCADGlobal.snapManager.nearestSnap(this.snapList, snapPoint.x, snapPoint.y);
      if (snap) {
        snapPoint.x = snap.point.x;
        snapPoint.y = snap.point.y;
        snaped = true;
        ({ x: lockX, y: lockY } = marietta.webcad.manager.SnapManager.getConstrainedAxes(snap.snap));
      }
      return {
        point: snapPoint, snaped, distance: snap ? snap.point.distance : 0, lockX, lockY,
      };
    }

    /**
    * 矢印位置を合わせる
    * */
    setArrowPositions() {
      // 頂点作成
      const points: number = this.target.itemInfo.dotList.length;
      let cornerPicker: marietta.webcad.control.parts.RoomCornerDragger;
      let movePicker: marietta.webcad.control.parts.RoomMovePickerWall;
      let i: number;
      let point1: marietta.core.Point;
      let point2: marietta.core.Point;
      let angle: number;
      let pRadian: number;
      for (i = 0; i < this.movePickerWallList.length; i += 1) {
        movePicker = this.movePickerWallList[i];
        movePicker.firstDot = this.target.itemInfo.dotList[i].point;
        movePicker.movePickerLength = this.movePickerWallList.length;
        if (i === this.target.itemInfo.dotList.length - 1) {
          movePicker.secondDot = this.target.itemInfo.dotList[0].point;
        } else {
          movePicker.secondDot = this.target.itemInfo.dotList[i + 1].point;
        }
        point1 = new marietta.core.Point(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
        point2 = (i === points - 1) ? new marietta.core.Point(this.target.itemInfo.dotList[0].x, this.target.itemInfo.dotList[0].y) : new marietta.core.Point(this.target.itemInfo.dotList[i + 1].x, this.target.itemInfo.dotList[i + 1].y);
        // 角度
        pRadian = Math.atan2((point1.x - point2.x), (point1.y - point2.y));
        angle = pRadian / (Math.PI / 180);
        movePicker.rotate(-angle);
      }
      for (i = 0; i < this.cornerPickerList.length; i += 1) {
        cornerPicker = this.cornerPickerList[i];
        // cornerPicker.cornerPickerLength = this.cornerPickerList.length;
        cornerPicker.move(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
      }
      this.target.highlight(true);
    }

    hideToolTips() {
      for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
        (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).disableDragger();
      }

      for (let i: number = 0; i < this.movePickerWallList.length; i += 1) {
        (this.movePickerWallList[i] as marietta.webcad.control.parts.RoomMovePickerWall).disableDragger();
      }
    }

    showToolTips() {
      for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
        (this.cornerPickerList[i] as marietta.webcad.control.parts.RoomCornerDragger).enableDragger();
      }

      for (let i: number = 0; i < this.movePickerWallList.length; i += 1) {
        (this.movePickerWallList[i] as marietta.webcad.control.parts.RoomMovePickerWall).enableDragger();
      }
    }

  // hideSettingButtons = () => {
  //   for (let i: number = 0; i < this.movePickerWallList.length; i++) {
  //     (this.movePickerWallList[i] as marietta.webcad.control.parts.RoomMovePickerWall).btnSetting.hide();
  //   }
  // }
}
